import styled from 'styled-components';

const GapElement = styled.div`
  display: block;
  margin-top: ${(props: any) => props.top || 0}px;
  margin-left: ${(props: any) => props.left || 0}px;
  margin-right: ${(props: any) => props.right || 0}px;
  margin-bottom: ${(props: any) => props.bottom || 0}px;
` as any;

export interface IProps {
  /** amount of space at top of gap in pixels */
  top?: number;
  /** amount of space to left of gap in pixels */
  left?: number;
  /** amount of space to right of gap in pixels */
  right?: number;
  /** amount of space at bottom of gap in pixels */
  bottom?: number;
}

export const Gap = (props: IProps) => {
  return <GapElement {...props} data-testid="Gap" />;
};
